import { Box, IconButton, Typography } from '@mui/material';
import React, { FC } from 'react';
import { COLORS } from '../../../../constants/constants';
import { Filter, FilterOption } from '../../filter-types';
import { ReactComponent as ChipExitIcon } from '../../../../images/chip-exit.svg';

interface FilterChipProps {
    filterOption: { filter: Filter; optionValue: FilterOption };
    onCloseChip?: (name?: string, optionValue?: FilterOption) => void;
}

const FilterChip: FC<FilterChipProps> = ({ filterOption, onCloseChip }) => {
    return (
        <Box
            className="border-color-b background-color-blst background-color-hover color-b"
            sx={{
                display: 'flex',
                alignItems: 'center',
                border: '1px solid',
                borderRadius: '40px',
                px: 1,
                mr: 1,
                mb: 1,
                justifyContent: 'space-between',
            }}
        >
            <Typography sx={{ fontWeight: '500', textWrap: 'nowrap' }} className="color-b">
                {`${filterOption.filter.name}: ${filterOption.optionValue.label}`}
            </Typography>
            <IconButton
                onClick={() => {
                    filterOption && onCloseChip?.(filterOption.filter.originalName, filterOption.optionValue);
                }}
                sx={{
                    'p': 0,
                    'ml': 1,
                    'fill': COLORS.BRAND,
                    '&:hover': {
                        fill: `${COLORS.BRAND_HOVER}`,
                    },
                    '&:active': {
                        fill: `${COLORS.BRAND_ACTIVE} !important`,
                    },
                }}
            >
                <ChipExitIcon />
            </IconButton>
        </Box>
    );
};

export default FilterChip;
